export const findAverageOrUndefined = (a, b) => {
    const aIsNumber = isNumber(a);
    const bIsNumber = isNumber(b);
    if (!aIsNumber && !bIsNumber) {
        return undefined;
    }
    if (!aIsNumber) {
        return b;
    }
    if (!bIsNumber) {
        return a;
    }
    return (a + b) / 2;
};
export const isNumber = (a) => {
    return a != null && !isNaN(a);
};
export const findMaxOrUndefined = (a, b) => {
    const aIsNumber = isNumber(a);
    const bIsNumber = isNumber(b);
    if (!aIsNumber && !bIsNumber) {
        return undefined;
    }
    if (!aIsNumber) {
        // @ts-expect-error ts2322: b is a number based on check above
        return b;
    }
    if (!bIsNumber) {
        return a;
    }
    return Math.max(a, b);
};
//# sourceMappingURL=mos_quality_score_utils.js.map